import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

function Square(props) {
	return (
		<button
			className="square"
			onClick={props.onClick}
		>
			{props.value}
		</button>
	)
}

class Board extends React.Component {
	renderSquare(i) {
		return (
			<Square
				value={this.props.squares[i]}
				onClick={() => this.props.onClick(i)}
			/>
		);
	}

	render() {
		return (
			<div>
				<div className="board-row">
					{this.renderSquare(0)}
					{this.renderSquare(1)}
					{this.renderSquare(2)}
				</div>
				<div className="board-row">
					{this.renderSquare(3)}
					{this.renderSquare(4)}
					{this.renderSquare(5)}
				</div>
				<div className="board-row">
					{this.renderSquare(6)}
					{this.renderSquare(7)}
					{this.renderSquare(8)}
				</div>
			</div>
		);
	}
}

class Game extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			history: [
				{ squares: Array(9).fill(null) }
			],
			step: 0,
			xIsNext: true
		}
	}

	handleClick(i) {
		const { history: prevHistory, step } = this.state
		const history = prevHistory.slice(0, step + 1)
		const current = history[history.length - 1]
		const squares = Array.from(current.squares)
		if (calculateWinner(squares) || squares[i]) {
			return
		}
		squares[i] = this.state.xIsNext ? 'X' : 'O'
		this.setState({
			history: history.concat([{ squares }]),
			step: history.length,
			xIsNext: !this.state.xIsNext
		})
	}

	jumpTo(step) {
		this.setState({
			step,
			xIsNext: (step % 2) === 0
		})
	}

	render() {
		const { history, step } = this.state
		const current = history[step]
		const winner = calculateWinner(current.squares)
		let status
		if (winner) {
			status = `Winner: ${winner}`
		} else {
			status = `Next player: ${this.state.xIsNext ? 'X' : 'O'}`;
		}

		return (
			<div className="game">
				<div className="game-board">
					<Board squares={current.squares} onClick={i => this.handleClick(i)} />
				</div>
				<div className="game-info">
					<div>{status}</div>
					<ol>
						{
							history.map((_, step) => {
								return (
									<li key={step}>
										<button onClick={() => this.jumpTo(step)}>
											{step ? `Go to step ${step}` : 'Go to game start'}
										</button>
									</li>
								)
							})
						}
					</ol>
				</div>
			</div>
		);
	}
}

// ========================================

ReactDOM.render(
	<Game />,
	document.getElementById('root')
);

function calculateWinner(squares) {
	const lines = [
		[0, 1, 2],
		[3, 4, 5],
		[6, 7, 8],
		[0, 3, 6],
		[1, 4, 7],
		[2, 5, 8],
		[0, 4, 8],
		[2, 4, 6],
	];
	for (let i = 0; i < lines.length; i++) {
		const [a, b, c] = lines[i];
		if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
			return squares[a];
		}
	}
	return null;
}
